export default "__VITE_ASSET__pWqaf0Cb__"